import type { Transaction } from '../core'
import { formatCurrency } from '../core/utils/NumberFormatting'

export const formatValueByType = (value: number, type: string, format: string): string => {
  if (type === 'amount') return formatCurrency(value, format)
  if (type === 'percent') return `${value}%`
  return String(value)
}

export const selectTransactionsByGuids = (
  detailedTransactions: Transaction[],
  guids: string[] | undefined,
): Transaction[] => {
  if (!guids?.length) return []
  const guidSet = new Set(guids)
  return detailedTransactions.filter((transaction) => guidSet.has(transaction.guid))
}
